import { isPlatform } from '@ionic/vue'

const ready = ref(false)
const loading = ref(false) // Für globale Ladeanzeige
const layout = ref<'onboarding' | 'app' | 'web'>('onboarding')
const error = ref<string | undefined>(undefined)

export default function useApp() {
	if (isPlatform('capacitor')) {
		layout.value = 'app'
	} else {
		layout.value = 'web'
	}

	const refresh = async () => {
		console.debug('Refreshing app data...')
		try {
			await useTenant().fetchTenants()
			await useAssociations().refresh()
			await useCreatorAssociations().refresh()
			await useUserMembership().refresh()
			await useIdnow().fetchStatus()
			console.debug('App data refreshed successfully')
		} catch (error) {
			console.error('Error during app refresh:', error)
			throw createError({ statusCode: 500, statusMessage: 'Error during app refresh' })
		}
	}

	return {
		ready,
		loading,
		layout,
		error,
		refresh,
	}
}
